module.exports = __webpack_public_path__ + "static/img/flexible-bg-ipad-1.56107de7.png";